<template>
  <div class="channelDevConfig clearfix" >
      <div class="right">
      <div class="operation-panel">
        <span  v-loading="loading" element-loading-spinner="el-icon-loading" style="margin-left: 20px"></span>
        <span
          @click="updateDev"  class="opearBtn update">
                  更新设备信息
                  <span v-if="loading" style="color: #ffcc99">(正在更新...) </span>
                  <span v-if="loadingSuc" style="color: #20a0ff">(更新成功!) </span>
                  <span v-if="loadingFail" style="color: red">(更新失败!) </span>
                </span>
        <span class="opearBtn save"
              @click="distribution">
                保存设备信息
        </span>
        <el-input v-model="devName" class="input" placeholder="请输入设备名称查询">
          <el-button @click="loadData" slot="append" icon="el-icon-search">查询</el-button>
        </el-input>
        </div>
        <div style="margin-top: 10px;">
        <el-table border stripe :data="tableData" header-row-class-name="table-header" fit    >
          <el-table-column type="index" label="序号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="channelName" label="设备名称"  align="center">
          </el-table-column>
          <el-table-column prop="inOutType" label="进/出"  align="center" >
            <template slot-scope="scope">
              <el-select v-model=scope.row.inOutType  clearable>
                <el-option label="进" value="1"></el-option>
                <el-option label="出" value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="indexCode" label="设备号"  align="center" >
          </el-table-column>
          <el-table-column prop="isOnline" label="是否在线"  align="center" :formatter="formatterIsOnline" >
          </el-table-column>
          <el-table-column prop="assignTime" label="添加时间"  align="center">
          </el-table-column>
        </el-table>
          <div class="pagination-container ">
            <v-pagination @pageChange="onCurrentChange"  :total="total" :isShow="showPagination" :page="page"></v-pagination>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import api from '@/api';
  import { session } from '@/util'
  import basetable from '@/mixins/base-table';
  import vRules from '@/config/validate_rules';

  export default {
    components:{},
    mixins: [basetable],
    props:{},
    data(){
      const user = session('user');
      return {
        houseName:"",
        loadingFail:false,
        loadingSuc:false,
        loading:false,
        showMessage:false,
        distributionDevShow:false,
        user: user,
        // 最终的树数据
        schoolOrganization :null,
        schoolOrganizationProp: {
          label: 'lable',
          children: 'children'
        },
        tableData1:[],
        tableData:[],
        devName:"",
        selDev:[],
        selDev1:[]
      }
    },
    watch:{},
    computed:{

    },
    methods:{
      loadData(){
        let str = '';
        let schoolId = this.user.schoolId;
        str +="schoolId="+schoolId;
        if(this.devName){
          str+="&&channelName="+this.devName;
        }
        api.systemConfig.findDeviceList(str).then(res=>{
          this.tableData = res.data;
       });
      },

      distribution(){
        let list = [];
        if(this.tableData===null||this.tableData.length===0){
          this.showTip("没有待保存的通道设备!","error");
          return ;
        }
        for(let x of this.tableData) {
          let obj = {};
          obj.id = x.id;
          obj.inOutType = x.inOutType;
          list.push(obj);
        }
          api.systemConfig.allotDevice(list).then(res=>{
          if(res.code===0){
         this.openWarningDialog("保存成功","设备信息保存成功");
          this.loadData();
        }else{
          this.showTip(res.message,"error");
        }
      });
      },
      formatterIsOnline(row){
        let isOnline = row.isOnline;
        if(isOnline===1){
          return "是";
        }else{
          return "否";
        }
      },

      openWarningDialog(title, msg) {
        let html = `<div style="width:400px;height:158px;padding:30px 50px;text-align: center">
                            <div style="margin-bottom:20px;"><span class="el-icon-success" style="color: #FD8C25;font-size: 50px;"></span> </div>
                            <p>${msg}!</p>
                        </div>`;
        this.$alert(html, title, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          showCancelButton: false
        }).then(() => {})
      },


      updateDev(){
        this.loadingSuc = false;
        this.loadingFail = false;
        this.loading = true;
        api.systemConfig.updateDevice().then(res=>{
          this.loading = false ;
        if(res.code===0){
          this.loadingSuc=true;
          this.loadData();
        }else{
          this.loadingFail = true;
        }
      });
      },

    },
    created(){
    },
    mounted(){}
  }
</script>
<style lang="scss" >
  html {
    height: auto;
  }
  .red {
    color: red;
  }



  .el-button {
    padding: 6px 15px;
  }
  .el-form-item__label,.el-dialog__body {
    color: #333;
  }
  .vl-notify {
    z-index: 2018;
    padding: 0;
  }
  .vl-notify .vl-notify-btns {
    padding: 0;
    text-align: center;
  }
  .warning {
    color: #E6A23C;
  }

  .channelDevConfig{
    width: 1200px;
    padding: 0;
    margin: 0;
    overflow: hidden;
    .left {
      width: 300px;
      min-height: 630px;
      float: left;
      .title {
        width: 100%;
        padding:0 20px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        background-color: #26aef3;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      .box {
        padding: 0px 0;
        height: 590px;
        border: 1px solid #dbdbdb;
        border-top: none;
        overflow: auto;
        .tree-box {
          color: #333;
          .label-text {
            margin-right: 15px;
            color: #333;
          }
          .icon {
            margin-right: 8px;
            color: #333;
            font-weight: bold;
          }
        }
      }
    }
    .right {
      width: 97%;
      margin: 0 20px;
      float: left;
      border:1px solid #dbdbdb;
      .operation-panel {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        background-color: #f0f0f0;
        .opearBtn{
          &.save {
            &:before {
              display: inline-block;
              vertical-align: middle;
              content: '';
              width: 18px;
              height: 18px;
              background-image: url('save.png');
            }
            &:hover {
              color: #26aef3;
            }
          }

          &.update {
            margin-left: 10px;
            &:before {
              display: inline-block;
              vertical-align: middle;
              content: '';
              width: 24px;
              height: 18px;
            }
            &:hover {
              color: #26aef3;
            }
          }


        }
        .btn {
          display: inline-block;
          margin-right: 40px;
          color: #333;
          font-size: 14px;
          cursor: pointer;
        }
        .input {
          width: 300px;
          float: right;
          margin-top: 5px;
          .el-input__inner {
            border: 1px solid #26aef3;
            border-right: none;
          }
          .el-input-group__append {
            border: 1px solid #26aef3;
            border-left: none;
            background-color: #26aef3;
            color: #fff;
          }
        }
      }

    }

    .operation-panel {
      height: 40px;
      line-height: 40px;
      padding: 0 20px;
      background-color: #f0f0f0;
      .opearBtn {
        margin-left: 30px;
        cursor: pointer;

      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/pages/systemConfig/channelDevConfig.vue